<template>
    <div id="todo-app">
        <div class="mb-4">
            <vs-button type="border" @click="activePrompt = true">Ajouter une tâche</vs-button>
            <vs-popup
                    :title="(input_task.id ? 'Modifier une' : 'Nouvelle') + ' tâche'"
                    accept-text= "Ajouter"
                    button-cancel = "border"
                    :buttons-hidden="true"
                    @accept="submitForm"
                    cancel-text="Annuler"
                    :active.sync="activePrompt">
                <form>
                    <div class="vx-row">
                        <div class="vx-col w-full">
                            <vs-input
                            @keyup="changeverifier('title')"
                            :danger="input_task_error.title"
                            :danger-text="input_task_error.title ? 'Le titre de la tâche est réquis.' : ''"
                            name="Nom" label="Tâche *" class="w-full mb-4 mt-5" placeholder="Tâche *" v-model="input_task.title" />
                        </div>
                        <div class="vx-col w-full">
                            <vs-textarea
                                @keyup="changeverifier('content')"
                                :class="input_task_error.content ? 'ccmt' : ''"
                                label="Description *" v-model="input_task.content"/>
                                <p class="span-text-validation" v-if="input_task_error.content" :style="(!input_task_error.content) ? '' : 'color:red; margin-top: -18px; margin-bottom: 20px'"> Le contenu de la tâche est réquis. </p>
                        </div>
                    </div>
                </form>

                <div style="margin-bottom: 10px !important;">
                    <vs-button class="mr-6" @click="submitForm" :disabled="!isFormValid"> {{ input_task.id ? 'Modifier' : 'Ajouter' }} </vs-button>
                    <vs-button type="border" color="danger" @click="activePrompt = false, initValues()">Annuler</vs-button>
                </div>
            </vs-popup>
        </div>
        <vue-perfect-scrollbar class="todo-content-scroll-area" :settings="settings" ref="taskList" :key="$vs.rtl">
            <transition-group class="todo-list" name="list-enter-up" tag="ul" appear>
                <li class="cursor-pointer todo_todo-item" v-for="todo in todoLists" :key="todo.id">
                    <div class="px-4 py-4 list-item-component">
                        <div class="vx-row">
                            <div class="vx-col w-full sm:w-5/6 flex sm:items-center sm:flex-row flex-col">
                                <div class="flex items-center">
                                    <vs-checkbox class="w-8 m-0 vs-checkbox-small" v-model="todo.is_completed" @change.stop="toggleis_completed(todo.id)" />
                                    <h6 class="todo-title" :class="{'line-through': todo.is_completed}">{{ todo.title }}</h6>
                                </div>
                            </div>
                            <div class="vx-col w-full sm:w-1/6 ml-auto flex sm:justify-end">
                                <feather-icon
                                        icon="StarIcon"
                                        class="cursor-pointer"
                                        :svgClasses="[{'text-warning stroke-current': todo.is_important}, 'w-5', 'h-5 mr-4']"
                                        @click.stop="toggleis_important(todo.id)" />
                                <feather-icon
                                        icon="EyeIcon"
                                        class="cursor-pointer"
                                        svgClasses="w-5 h-5 mr-4"
                                        @click.stop="detail(todo)" />
                                <feather-icon
                                        icon="EditIcon"
                                        class="cursor-pointer"
                                        svgClasses="w-5 h-5 mr-4"
                                        @click.stop="todo_edit(todo)" />
                                <feather-icon
                                        icon="TrashIcon"
                                        class="cursor-pointer"
                                        svgClasses="w-5 h-5"
                                        @click.stop="openConfirm(todo.id)" />
                            </div>
                        </div>
                        <div class="vx-row" v-if="todo.content">
                            <div class="vx-col w-full">
                                <p class="mt-2 truncate" :class="{'line-through': todo.is_completed}">{{ todo.content }}</p>
                            </div>
                        </div>
                    </div>

                </li>
            </transition-group>
        </vue-perfect-scrollbar>
    </div>
</template>

<script>
    let base_self;
    let input_tempon = {
        request_id: '',
        title: '',
        content: '',
    };
    let input_task_error_tempon = {
        title: false,
        content: false,
    };

    import VuePerfectScrollbar from "vue-perfect-scrollbar";
    export default {
        components: {VuePerfectScrollbar},
        data() {
            return {
                activePrompt: false,
                input_task_error: JSON.parse(JSON.stringify(input_task_error_tempon)),
                input_task: JSON.parse(JSON.stringify(input_tempon)),
                is_completed: false,
                settings : {
                    maxScrollbarLength : 60,
                    wheelSpeed         : 0.30,
                },

            }
        },
        methods: {
            test(){
                alert('cool')
            },
            changeverifier (libelle) {
                if (!base_self.input_task[libelle].length) {
                    base_self.input_task_error[libelle] = true;
                } else {
                    base_self.input_task_error[libelle] = false;
                }
            },
            initValues () {
                base_self.activePrompt = false;
                base_self.input_task = JSON.parse(JSON.stringify(input_tempon));
                base_self.input_task_error = JSON.parse(JSON.stringify(input_task_error_tempon));
            },
            async submitForm() {
              base_self.$vs.loading()
                //
                this.input_task.request_id = window.SingleRequestApp.$route.params.id

                let response;
                if (this.input_task.id) {
                    response = await base_self.$store.state.requests_tasks_update(this.input_task);
                  base_self.$vs.loading.close()
                    if (response.data.status) {
                        window.GETCCMT.success('La tâche est modifiée avec succès.', response);

                        this.initValues()
                    } else {
                        window.GETCCMT.error({ message: 'La modification de la tâche a échouée.' });
                    }
                } else {
                  base_self.$vs.loading()
                    response = await base_self.$store.state.requests_tasks_create(this.input_task);
                    if (response.data.status) {
                      base_self.$vs.loading.close()
                        window.GETCCMT.success('La tâche est ajoutée avec succès.', response);

                        this.initValues()
                    } else {
                      base_self.$vs.loading.close()
                        window.GETCCMT.error({ message: 'L\'ajout de la tâche a échouée.' });
                    }
                }

                window.SingleRequestApp.general();
            },
            async toggleis_important(id) {
              base_self.$vs.loading()
                let response = await base_self.$store.state.requests_tasks_is_important({ id });
                if (response.data.status) {
                  base_self.$vs.loading.close()
                    window.GETCCMT.success('La tâche est modifiée avec succès.', response);
                } else {
                  base_self.$vs.loading.close()
                    window.GETCCMT.error({ message: 'La modification de la tâche a échouée.' });
                }
                window.SingleRequestApp.general();
            },
            async toggleis_completed(id) {
              base_self.$vs.loading()
                let response = await base_self.$store.state.requests_tasks_is_completed({ id });
                if (response.data.status) {
                  base_self.$vs.loading.close()
                    window.GETCCMT.success('La tâche est modifiée avec succès.', response);
                } else {
                  base_self.$vs.loading.close()
                    window.GETCCMT.error({ message: 'La modification de la tâche a échouée.' });
                }
                window.SingleRequestApp.general();
            },
            todo_edit(item) {
                this.initValues()
                base_self.input_task = JSON.parse(JSON.stringify(item));
                base_self.activePrompt = true
            },
            async detail(item) {
                this.$vs.dialog({
                    color: 'primary',
                    title: item.title,
                    text: item.content,
                    acceptText: 'OK',
                    cancelText: 'Annuler',
                })
            },
            async openConfirm(id) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Confirmer la suppression?',
                    acceptText: 'Confirmer',
                    cancelText: 'Annuler',
                    accept: async () => {
                      base_self.$vs.loading()
                        let response = await base_self.$store.state.requests_tasks_delete({ id });

                        if (response.data.status) {
                          base_self.$vs.loading.close()
                            window.GETCCMT.success('La tâche est supprimée avec succès.', response);
                        } else {
                          base_self.$vs.loading.close()
                            window.GETCCMT.error({ message: 'La suppression de la tâche a échouée.' });
                        }
                        window.SingleRequestApp.general();
                    }
                })
            }
        },
        computed: {
            isFormValid () {
                var is_ok = true;

                if (!base_self.input_task.title.length ) is_ok = false;
                if (!base_self.input_task.content.length ) is_ok = false;

                return is_ok;
            },
            todoLists () {
                return window.SingleRequestApp.tasks;
            }
        },
        async created() {
            base_self = this;
        }

    }
</script>

<style lang="scss">
    @import "@/assets/scss/vuesax/apps/todo.scss";
    .ccmt {
        color: red;
        border: 1px solid rgb(251, 3, 3) !important;
    }
</style>
